import { render, staticRenderFns } from "./ProfileInterview.vue?vue&type=template&id=663fecbd&scoped=true"
import script from "./ProfileInterview.vue?vue&type=script&lang=js"
export * from "./ProfileInterview.vue?vue&type=script&lang=js"
import style0 from "./ProfileInterview.vue?vue&type=style&index=0&id=663fecbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663fecbd",
  null
  
)

/* custom blocks */
import block0 from "./ProfileInterview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports